<section class="main">
  <ts-page-header>
    <ng-container page-header-title>
      <h5 class="m-0 font-medium">{{ title }}</h5>
    </ng-container>
    <ng-container page-header-action-buttons>
      <section class="flex flex-row gap-2">
        @if (false) {
          <ts-button
            color="accent"
            type="stroked"
            icon="ts_file-save"
            [matTooltip]="!dataset?.length ? 'Nothing to export' : 'Export as CSV'"
            [disabled]="!dataset?.length"
            (buttonClick)="exportCsv()"
          >
            Export
          </ts-button>
        }
        @if (canAddDeal) {
          <div class="flex flex-row gap-2 justify-between items-center">
            <ts-button
              appAuthorize="DEALS_CREATE"
              variant="secondary"
              icon="ts_link"
              [matTooltip]="'Link deal'"
              (buttonClick)="addDeal('link')"
            >
              Link Deal
            </ts-button>
            <ts-button
              appAuthorize="DEALS_CREATE"
              data-cy="create-new-property"
              icon="add"
              color="primary"
              [matTooltip]="'Add new deal'"
              (buttonClick)="addDeal('add')"
            >
              Add Deal
            </ts-button>
          </div>
        }
        @if (addNewObjectConfig) {
          <div class="flex flex-row gap-2 justify-between items-center">
            <ts-button
              data-cy="create-new-property"
              icon="add"
              color="primary"
              [matTooltip]="addNewObjectConfig.tooltip"
              (buttonClick)="addNewObject()"
            >
              {{ addNewObjectConfig.label }}
            </ts-button>
          </div>
        }
      </section>
    </ng-container>
    <ng-container page-header-action-bar>
      <section class="flex gap-2 items-center">
        <!-- Search Bar -->
        <ts-input
          class="max-h-ts-input-list-search w-ts-input-list-search"
          [formControl]="searchInputControl"
          type="text"
          size="sm"
          icon="ts_search"
          placeholder="Search"
        ></ts-input>

        <ng-container *ngIf="!useFieldSelector; else projectFieldSelector">
          <field-defs-panel
            [savedView]="savedView"
            [fieldDefs]="fieldDefs"
            [savedView]="savedView"
            [displayColumns]="displayColumns"
            [sortColumnToFirst]="false"
            (columnsChanged)="onColumnsChanged($event)"
          ></field-defs-panel>
        </ng-container>
        <ng-template #projectFieldSelector>
          <app-field-selector
            [columns]="displayColumns"
            [relatedTo]="relatedToType"
            (fieldSelectionChanged)="onColumnsChanged($event)"
          >
            Fields
            @if (displayColumns?.length) {
              <ts-badge [value]="displayColumns.length" [type]="'info'"></ts-badge>
            }
          </app-field-selector>
        </ng-template>

        <!-- List Filter Button -->
        <ts-button
          type="stroked"
          color="accent"
          class="xs:hidden"
          [tsOverlayTriggerFor]="filtersOverlayBox"
          [matTooltip]="'Apply filters'"
        >
          <ts-icon icon="ts_filter-list" class="mr-2"></ts-icon>
          Filter
          <ng-container *ngIf="filterCounter">
            <ts-badge [value]="filterCounter" [type]="'info'"></ts-badge>
          </ng-container>
        </ts-button>
      </section>
    </ng-container>
  </ts-page-header>

  <main class="products-list">
    <div class="loader" *ngIf="tableIsLoading">
      <mat-progress-bar class="table-loading-bar" [mode]="'indeterminate'"></mat-progress-bar>
    </div>
    <section class="table-wrapper">
      <ts-table
        [columnDefs]="columnDefs"
        [rowData]="dataset"
        [data]="data"
        [autoHeight]="false"
        [gridOptions]="gridOptions"
        [hasOpenDetailsColumn]="true"
        [autoSizeAllColumns]="false"
        (sortChanged)="onSortChanged($event)"
        (openDetails)="handleOpenDetails($event)"
        (cellEditingStopped)="onCellEditingStopped($event)"
        (onColumnMove)="onColumnMoved($event)"
      >
      </ts-table>
    </section>
    <ts-paginator
      [totalItems]="pagination.length"
      [pageSize]="pagination.size"
      [activePage]="pagination.page + 1"
      (pageChanged)="page($event)"
    ></ts-paginator>
  </main>
</section>

<!-- List Filters Panel -->
<ts-overlay
  #filtersOverlayBox
  position="bottom"
  [transparentBackdrop]="true"
  (closeByBackdropClick)="onCloseByBackdropClick()"
>
  <ts-filter
    size="large"
    [fields]="typeFields | async"
    [filters]="filterValueList | async"
    [lookupContract]="lookupService"
    [hasGroups]="false"
    (addItem)="onAddFilterItem()"
    (filterDefChange)="onFilterDefChanged($event)"
    (filterRemove)="onFilterRemoved($event)"
    (filterClear)="onFilterCleared()"
    (filterApply)="onFilterApplied()"
  ></ts-filter>
</ts-overlay>
